<template>
  <div class="panel-card import-panel">
    <div class="section-title-row">
      <div>
        <div class="section-title" style="margin-bottom: 4px">Audit i ndryshimeve</div>
        <p class="panel-subtitle">Perditesuar = cmimi ne Globe. Financa 1 + Financa 2 = OK / deshtime (edhe kur Globe nuk ndryshoi cmimin).</p>
      </div>
      <button type="button" class="button is-small is-light" :disabled="po.priceBatchLoading" @click="po.loadPriceBatches">
        Rifresko
      </button>
    </div>

    <div class="quick-actions">
      <input
        v-model="po.priceBatchFilterSearch"
        class="input-clean"
        type="text"
        placeholder="Kerko sipas skedarit ose ID..."
        @keyup.enter="po.loadPriceBatches"
      />
      <select v-model="po.priceBatchFilterStatus" class="input-clean" style="max-width: 180px" @change="po.loadPriceBatches">
        <option value="">Te gjitha statuset</option>
        <option value="scheduled">Ne pritje</option>
        <option value="applying">Duke aplikuar</option>
        <option value="applied">Aplikuar</option>
        <option value="failed">Deshtuar</option>
        <option value="reverted">Rikthyer</option>
        <option value="cancelled">Anuluar</option>
      </select>
      <button type="button" class="button is-small" @click="po.loadPriceBatches">Filtro</button>
    </div>

    <div v-if="po.priceBatchLoading" class="empty-note">Duke ngarkuar auditin...</div>
    <div v-else-if="!po.priceBatches.length" class="empty-note">Nuk ka ndryshime te audituara ende.</div>
    <div class="manual-table-wrap audit-table-wrap" v-else>
      <table class="table is-fullwidth is-narrow audit-table">
        <thead>
          <tr>
            <th style="width: 44px"></th>
            <th>Data</th>
            <th>Orari</th>
            <th>Skedari</th>
            <th>Lloji</th>
            <th class="has-text-right">Produkte</th>
            <th class="has-text-right" title="Cmimi u ndryshua ne Globe">Perditesuar</th>
            <th class="has-text-right" title="Sinkronizim Financa 1 dhe Financa 2: OK / dështime">Financa 1+2 OK / dështim</th>
            <th>Statusi</th>
            <th style="min-width: 260px">Veprime</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="batch in po.priceBatches" :key="`pb-${batch.id}`">
            <tr class="audit-row" :class="{ 'is-expanded': po.expandedPriceBatchId === batch.id }">
              <td>
                <button type="button" class="button is-small is-light audit-expand-btn" @click="po.togglePriceBatchDetail(batch.id)">
                  {{ po.expandedPriceBatchId === batch.id ? "−" : "+" }}
                </button>
              </td>
              <td>
                <div class="audit-primary">{{ po.formatLocalDateTime(batch.created_at) }}</div>
                <div class="audit-secondary">{{ batch.created_by_name || batch.created_by || "—" }}</div>
              </td>
              <td>
                <div class="audit-primary">{{ batch.apply_at ? po.formatLocalDateTime(batch.apply_at) : "—" }}</div>
                <div v-if="batch.applied_at" class="audit-secondary">Aplikuar: {{ po.formatLocalDateTime(batch.applied_at) }}</div>
              </td>
              <td>
                <div class="audit-primary audit-filename" :title="batch.filename || batch.source || ''">
                  {{ batch.filename || batch.source || "—" }}
                </div>
              </td>
              <td>
                <span class="chip muted">
                  {{ (batch.target_field || "price") === "default_price" ? "Cmim baze" : "Cmim" }}
                </span>
              </td>
              <td class="has-text-right">{{ batch.product_count }}</td>
              <td class="has-text-right">{{ batch.updated_count }}</td>
              <td class="has-text-right">
                <span class="audit-f5-ok">{{ batch.synced_ok }}</span>
                <span class="audit-f5-sep">/</span>
                <span :class="batch.synced_failed ? 'audit-f5-fail' : 'audit-secondary'">{{ batch.synced_failed }}</span>
              </td>
              <td>
                <span :class="po.priceBatchStatusClass(batch.status)">
                  {{ po.priceBatchStatusLabel(batch.status) }}
                </span>
              </td>
              <td>
                <div class="audit-actions">
                  <button
                    type="button"
                    class="button is-small is-light"
                    :class="{ 'is-loading': po.priceBatchExportId === batch.id }"
                    :disabled="po.priceBatchActionBusy()"
                    @click="po.downloadPriceBatchCsv(batch)"
                  >
                    CSV
                  </button>
                  <button
                    v-if="po.canApplyScheduledPriceBatchNow(batch)"
                    type="button"
                    class="button is-small is-primary"
                    :class="{ 'is-loading': po.priceBatchApplyNowId === batch.id }"
                    :disabled="po.priceBatchActionBusy()"
                    @click="po.requestApplyScheduledPriceBatchNow(batch)"
                  >
                    Apliko tani
                  </button>
                  <button
                    v-if="po.canCancelScheduledPriceBatch(batch)"
                    type="button"
                    class="button is-small is-warning"
                    :class="{ 'is-loading': po.priceBatchCancelId === batch.id }"
                    :disabled="po.priceBatchActionBusy()"
                    @click="po.requestCancelScheduledPriceBatch(batch)"
                  >
                    Anulo
                  </button>
                  <button
                    v-if="po.canResyncPriceBatchFailed(batch)"
                    type="button"
                    class="button is-small is-info"
                    :class="{ 'is-loading': po.priceBatchResyncId === batch.id }"
                    :disabled="po.priceBatchActionBusy()"
                    title="Riprovo sinkronizimin në Financa 1 dhe Financa 2 për produktet e dështuara (cmimi në Globe nuk ndryshon)"
                    @click="po.requestResyncPriceBatchFailed(batch)"
                  >
                    Riprovo Financa
                  </button>
                  <button
                    v-if="po.canRevertPriceBatch(batch)"
                    type="button"
                    class="button is-small is-warning"
                    :class="{ 'is-loading': po.priceBatchRevertId === batch.id }"
                    :disabled="po.priceBatchActionBusy()"
                    title="Vendos çmimin = çmim bazë aktual + sinkronizo Financa 1 dhe Financa 2"
                    @click="po.requestRevertPriceBatch(batch)"
                  >
                    Rikthe
                  </button>
                  <span v-else-if="batch.status === 'reverted'" class="audit-secondary">{{ po.formatLocalDateTime(batch.reverted_at) }}</span>
                  <span v-else-if="batch.status === 'cancelled'" class="audit-secondary">{{ po.formatLocalDateTime(batch.cancelled_at) }}</span>
                </div>
              </td>
            </tr>
            <tr v-if="po.expandedPriceBatchId === batch.id" class="audit-detail-row">
              <td colspan="10">
                <div class="audit-detail-card">
                  <div v-if="po.priceBatchDetailLoading === batch.id" class="empty-note">Duke ngarkuar detajet...</div>
                  <div v-else-if="!po.priceBatchDetails[batch.id]?.items?.length" class="empty-note">Nuk ka rreshta ne kete batch.</div>
                  <table v-else class="table is-fullwidth is-narrow audit-table">
                    <thead>
                      <tr>
                        <th>Kodi</th>
                        <th class="has-text-right">Cmim i vjeter</th>
                        <th class="has-text-right">Cmim i ri</th>
                        <th class="has-text-right">Cmim baze (skedar)</th>
                        <th class="has-text-right">Default ne ndryshim</th>
                        <th>Financa 1+2</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in po.priceBatchDetails[batch.id].items" :key="`pbi-${item.id}`">
                        <td><code class="sim-code">{{ item.code }}</code></td>
                        <td class="has-text-right">{{ po.money(item.old_price) }}</td>
                        <td class="has-text-right sim-price-new">{{ po.money(item.new_price) }}</td>
                        <td class="has-text-right">{{ item.file_base_price != null ? po.money(item.file_base_price) : "—" }}</td>
                        <td class="has-text-right">{{ item.default_price_at_change != null ? po.money(item.default_price_at_change) : "—" }}</td>
                        <td>
                          <span :class="item.synced_ok ? 'tag is-success is-light' : 'tag is-danger is-light'">
                            {{ item.synced_ok ? "OK" : "Fail" }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "PriceBatchAudit",
  inject: ["po"],
};
</script>
